const PI = Math.PI;
const AXIS = 6378245;
const ECCENTRICITY = 0.006693421622965943;

function outsideChina(lng, lat) {
  return lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271;
}

function transformLatitude(lng, lat) {
  let value =
    -100 +
    2 * lng +
    3 * lat +
    0.2 * lat * lat +
    0.1 * lng * lat +
    0.2 * Math.sqrt(Math.abs(lng));
  value +=
    ((20 * Math.sin(6 * lng * PI) + 20 * Math.sin(2 * lng * PI)) * 2) / 3;
  value +=
    ((20 * Math.sin(lat * PI) + 40 * Math.sin((lat / 3) * PI)) * 2) / 3;
  value +=
    ((160 * Math.sin((lat / 12) * PI) +
      320 * Math.sin((lat * PI) / 30)) *
      2) /
    3;
  return value;
}

function transformLongitude(lng, lat) {
  let value =
    300 +
    lng +
    2 * lat +
    0.1 * lng * lng +
    0.1 * lng * lat +
    0.1 * Math.sqrt(Math.abs(lng));
  value +=
    ((20 * Math.sin(6 * lng * PI) + 20 * Math.sin(2 * lng * PI)) * 2) / 3;
  value +=
    ((20 * Math.sin(lng * PI) + 40 * Math.sin((lng / 3) * PI)) * 2) / 3;
  value +=
    ((150 * Math.sin((lng / 12) * PI) +
      300 * Math.sin((lng / 30) * PI)) *
      2) /
    3;
  return value;
}

export function wgs84ToGcj02(lng, lat) {
  if (outsideChina(lng, lat)) return [lng, lat];
  const deltaLng = transformLongitude(lng - 105, lat - 35);
  const deltaLat = transformLatitude(lng - 105, lat - 35);
  const radLat = (lat / 180) * PI;
  let magic = Math.sin(radLat);
  magic = 1 - ECCENTRICITY * magic * magic;
  const sqrtMagic = Math.sqrt(magic);
  const convertedLng =
    lng + (deltaLng * 180) / ((AXIS / sqrtMagic) * Math.cos(radLat) * PI);
  const convertedLat =
    lat +
    (deltaLat * 180) /
      (((AXIS * (1 - ECCENTRICITY)) / (magic * sqrtMagic)) * PI);
  return [convertedLng, convertedLat];
}

export function haversineKm(left, right) {
  const toRadians = (value) => (value * PI) / 180;
  const latitudeDelta = toRadians(right.lat - left.lat);
  const longitudeDelta = toRadians(right.lng - left.lng);
  const latitudeA = toRadians(left.lat);
  const latitudeB = toRadians(right.lat);
  const value =
    Math.sin(latitudeDelta / 2) ** 2 +
    Math.cos(latitudeA) *
      Math.cos(latitudeB) *
      Math.sin(longitudeDelta / 2) ** 2;
  return 6371 * 2 * Math.atan2(Math.sqrt(value), Math.sqrt(1 - value));
}
